// Color mapping for mail categorization
export const COLORS_MAPPING = {
    "bg-white": "white",
    "bg-red-800": "rouge",
    "bg-orange-500": "orange",
    "bg-yellow-300": "jaune",
    "bg-lime-300": "citron vert",
    "bg-green-600": "vert",
    "bg-cyan-500": "cyan",
    "bg-blue-700": "bleu",
    "bg-pink-500": "rose",
    "bg-purple-500": "violet",
    "bg-gray-500": "gris",
} as const;

// Available colors for selection
export const AVAILABLE_COLORS = Object.keys(COLORS_MAPPING) as Array<keyof typeof COLORS_MAPPING>;
